const routes = [
    {
        path: "/payment/types",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "paymenttype_index"
        }
    }
];

export default routes;
